module.exports = __webpack_public_path__ + "static/memsource-find-settings-00c0f9b4619c5ca4d69e922c35d1b10e.jpg";